<template>
    <div>
        <h2>落箱用户登录</h2>
        <van-form @submit="onSubmit">
            <van-field v-model="name" name="name" label="姓名" placeholder="姓名"/>
            <van-field v-model="carno" name="carno" maxlength="7" label="车牌号" placeholder="车牌号"/>
            <van-field v-model="tel" name="tel" maxlength="11" type="tel" label="手机号" placeholder="手机号"/>
            <div style="margin: 16px;">
                <van-button round block type="info" native-type="submit">
                    提交
                </van-button>
            </div>
        </van-form>
        <tabbar :selected="selected"></tabbar>
    </div>
</template>

<script>
    import common from "../../common";
    import Vue from 'vue';
    import {Dialog, Form} from 'vant';
    import tabbar from '@/components/tabbar'

    Vue.use(Form);

    export default {
        components: {tabbar},
        data() {
            return {
                selected: "box",
                name: '',
                tel: '',
                carno: '',
            };
        },
        methods: {
            onSubmit(values) {
                localStorage.setItem('name', this.name);
                localStorage.setItem('carno', this.carno);
                localStorage.setItem('tel', this.tel);
                let querystring = require("querystring");
                this.$api.post("wx/container-yard/login",
                    querystring.stringify({
                        name: values.name,
                        carno: values.carno,
                        tel: values.tel,
                    })
                ).then(({data}) => {
                    if (data.status == 1) {
                        Dialog.alert({
                            message: data.msg,
                        }).then(() => {
                            this.$router.push({path: "/container-yard/home"});
                        });
                    } else {
                        Dialog.alert({
                            message: data.msg,
                        }).then(() => {

                        });
                    }
                });
            },
        },
        mounted() {
            // if (!!JSON.parse(common.getlocalStorage("userInfo"))) {
            //     this.name = JSON.parse(common.getlocalStorage("userInfo")).name;
            //     this.tel = JSON.parse(common.getlocalStorage("userInfo")).mobile;
            //     this.carno = JSON.parse(common.getlocalStorage("userInfo")).default_car_number;
            // } else {
                this.name = localStorage.getItem('name');
                this.carno = localStorage.getItem('carno');
                this.tel = localStorage.getItem('tel');
            // }
        },
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/container-yard/login.vue